import React, {FunctionComponent} from "react";

import {Annotation as AnnotationConfig} from './use-fingering-annotations';

const PADDING_H = 3;

interface AnnotationsProps {
  bounds: {
    height: number;
    width: number;
    x: number;
    y: number;
  };
  group: Array<AnnotationConfig>;
}

const Annotations: FunctionComponent<AnnotationsProps> = props => {
  const vm = useVM(props);

  return (
    <>
      {vm.annotations.map((a, i) => <Annotation key={i} {...a} />)}
    </>
  )
}

function useVM({bounds, group}: AnnotationsProps) {
  const annotations = group.map((a, i) => ({
    color: colorForGroupSize(a.groupSize),
    radius: (bounds.width / 2) - PADDING_H,
    text: a.text,
    x: bounds.x + PADDING_H,
    y: (bounds.y + bounds.height) - (((a.kind === 'left_hand' ? 0 : 1) + 1) * bounds.width)
  }));

  return {
    annotations
  }
}

interface AnnotationProps {
  color: string;
  radius: number;
  text: string;
  x: number;
  y: number;
}

const Annotation: FunctionComponent<AnnotationProps> = ({color, radius, text, x, y}) => {
  const cx = x + radius;
  const cy = y + radius;
  const outline = color === '#000' ? 'white' : color;

  return (
    <>
      <circle r={radius} fill={color} cx={cx} cy={cy} stroke={outline} strokeWidth={3} />
      {/* <circle r={radius} fill={color} cx={x} cy={y} /> */}
      <text alignmentBaseline='middle' x={cx} y={cy} fill='white' width={2 * radius} textAnchor='middle'>{text}</text>
      {/* <text x={x} y={y} fill='white'>{text}</text> */}
    </>
  )
}

export default Annotations;

function colorForGroupSize(groupSize: number) {
  switch (groupSize) {
    case 3: return '#ff928f';//salmon
    case 4: return '#83aab9';//orange
    default: return '#000';
  }
}
